<template>
  <slot v-if="price" :price :selected-offer>
    <AdvertisedPayment :price :selected-offer />
  </slot>
</template>

<script setup lang="ts">
import AdvertisedPayment from '~/scopes/product-core/components/presentationals/AdvertisedPayment/AdvertisedPayment.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'

const { selectedOffer } = useFetchPickers()
const { price } = useFetchProductPrice()
</script>
